export const PROFESSIONAL_OF_WORK_ZONE_ID = 2;
export const PROFESSIONAL_OF_WORK_ZONE_LABEL = 'Profissional de obra';

export const TIME_OF_PROFESSION_OPTIONS = [
  'Menos de 1 ano',
  '1 a 2 anos',
  '3 a 5 anos',
  '6 a 10 anos',
  'Mais de 10 anos',
];
